import { Button } from '@/components/Button'
import imgConfirmActionUrl from '@/assets/misc/img_confirm-action.svg'
import WorkspaceRolesIllustration from '@/components/SpotIllustration/WorkspaceRolesIllustration'
import { byDesign } from '@/infra/design'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'

export interface RejectDraftInReviewDialogProps {
  showing: boolean
  isRejectDraftPending: boolean
  onClose: () => unknown
  onRejectDraft: () => unknown
}

export function RejectDraftInReviewDialog({
  showing,
  isRejectDraftPending,
  onClose,
  onRejectDraft,
}: RejectDraftInReviewDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isRejectDraftPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentIllustration
          src={imgConfirmActionUrl}
          illustration={byDesign(undefined, WorkspaceRolesIllustration)}
        />
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            Do you want to request changes to your latest draft return?
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Please communicate with your Pro the changes you are requesting.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            variant="secondary"
            onPress={onClose}
            isDisabled={isRejectDraftPending}
          />
          <Button
            label="Request Changes"
            variant="destructive"
            isPending={isRejectDraftPending}
            isDisabled={isRejectDraftPending}
            onPress={onRejectDraft}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
